/* eslint-disable max-len */
import React from 'react';
import { convertUnitValues } from '../../shared/conversion-helper/unitConversion';

import '../../styles/parameters.scss';

function Saturation(props) {
  const { saturation = {}, units = {}, translateObject } = props;
  const {
    baso4 = '',
    caf2 = '',
    srso4 = '',
    lsi = '',
    sdi = '',
    caso4 = '',
    density = '',
    struvite = '',
    sio2 = '',
    osmotic_pressure = '',
    conductivity = '',
    mgoh2 = '',
  } = saturation;
  const { pressure } = units;

  // to add red color to txt when value exceed the limit by Abhishek 8-Dec-23
  // These function work as a class for the variables which will change the color to text to red if the value exceed the limit
  const isExceedOfNumber = (data = '', max = 100) => {
    const numValue = data.replace('%', '');
    return Number(numValue) >= max ? 'highlight-text f-right sub-text no_drag forground-Text-Label' : 'f-right sub-text no_drag forground-Text-Label';
  };

  // const isExceedOfNum = (data = '', max = 1) => {
  //   const numValue = data.replace('%', '');
  //   return Number(numValue) >= max ? 'highlight-text f-right sub-text no_drag forground-Text-Label' : 'f-right sub-text no_drag forground-Text-Label';
  // };

  return (
    <div className="saturation-modal">
      <div className="text-content no_drag M_Bold">{translateObject('Saturation Data (Feed water)')}</div>
      <div className="form-grid" style={{margin:'12px'}}>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular" data-testid="baso4">
          <div className='f-left no_drag'>BaSO<sub>4</sub></div>
          <div className={isExceedOfNumber(baso4)}>
            {baso4.replace('%', '')} %
          </div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular">
          <div className='f-left no_drag'>CaF<sub>2</sub></div>
          <div className={isExceedOfNumber(caf2)}>
            {caf2.replace('%', '')} %
          </div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular">
          <div className='f-left no_drag'>CaSO<sub>4</sub></div>
          <div className={isExceedOfNumber(caso4)}>
            {caso4.replace('%', '')} %
          </div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular" data-testid="sio2">
          <div className='f-left no_drag'>SiO<sub>2</sub></div>
          <div className={isExceedOfNumber(sio2)}>
            {sio2.replace('%', '')} %
          </div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular" data-testid="srso">
          <div className='f-left no_drag'>SrSO<sub>4</sub></div>
          <div className={isExceedOfNumber(srso4)}>{srso4.replace('%', '')} %</div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular">
          <div className='f-left no_drag'>Struvite</div>
          <div className={isExceedOfNumber(struvite)}>{struvite.replace('%', '')} %</div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular">
          <div className='f-left no_drag'>Mg(OH)<sub>2</sub></div>
          <div className={isExceedOfNumber(mgoh2)}>
            {mgoh2 ? mgoh2.replace('%', '') : '0.00'} %
          </div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular">
          <div className='f-left no_drag'>LSI</div>
          <div className='f-right sub-text no_drag forground-Text-Label'>{lsi}</div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular">
          <div className='f-left no_drag'>{translateObject('Stiff-Davis Index')}</div>
          <div className='f-right sub-text no_drag forground-Text-Label'>{sdi}</div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular">
          <div className='f-left no_drag'>{translateObject('Osmotic Pressure')}</div>
          <div className='f-right sub-text no_drag forground-Text-Label'>
            {convertUnitValues(osmotic_pressure, pressure)} {pressure}
          </div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular">
          <div className='f-left no_drag'>{translateObject('Conductivity')}</div>
          <div className='f-right sub-text no_drag forground-Text-Label'>{Number(conductivity).toFixed(2)} µS/cm</div>
        </div>
        <div className="box-field w-50 label-text sansW4SeLig S_Regular" data-testid='density'>
          <div className='f-left no_drag'>{translateObject('Density')}</div>
          <div className='f-right sub-text no_drag forground-Text-Label'>{density} kg/m3</div>
        </div>
      </div>
    </div>
  );
}

export default Saturation;
